import React from "react";
import BlogSidebar from "../components/blog/sidebar";
import Seo from "../components/common/seo";
import EventContent from "../components/events/content";
import { toPlainText } from "@portabletext/toolkit";

const Event = ({ pageContext }) => {
  const { event } = pageContext;

  return (
    <div className="blogpage container">
      <div className="left">
        <EventContent data={event} />
      </div>
      <div className="right">
        <BlogSidebar
          iframes={[
            "99ab7fab-3ed0-4d67-9561-e30633c2fc05",
            "99ab7fe1-472e-4d7d-adea-42a1b4fdb9ad",
          ]}
        />
      </div>
    </div>
  );
};

export default Event;

export function Head({ location, pageContext }) {
  const { event } = pageContext;
  const seoData = {
    title: event?.title,
    description: event.body ? toPlainText(event.body) : "",
    image: !!event?.images.length ? event.images[0] : "",
  };

  return <Seo location={location} data={seoData} />;
}
